import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { NAVEGACION } from '../../utilidades/interior.static';
import { ResponsiveService } from 'src/app/compartido/servicios/responsive.service';
import { AutorizacionService } from 'src/app/compartido/autorizacion/autorizacion.service';
import { AutenticacionService } from 'src/app/compartido/autenticacion/autenticacion.service';

@Component({
  selector: 'interior-pagina-principal',
  templateUrl: './pagina-principal.component.html',
  styleUrls: ['./pagina-principal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaginaPrincipalComponent implements OnInit {
  /* Navegación */
  protected readonly NAVEGACION = NAVEGACION;

  /* Mostrar categorías */
  protected mostrarCategoria: WritableSignal<Map<string, boolean>> = signal(new Map());

  /* Usuario */
  protected usuario$;

  constructor(
    private readonly _cdr: ChangeDetectorRef,
    protected readonly responsiveService: ResponsiveService,
    protected readonly autorizacionService: AutorizacionService,
    private readonly _autenticacionService: AutenticacionService,
  ) {
    this.usuario$ = this._autenticacionService.usuario$;
  }

  ngOnInit(): void {
    this.poblarMostrarCategoria$();
  }

  /**
   * Puebla si la categorías debe mostrarse.
   * @author Juan Corral
   */
  protected async poblarMostrarCategoria$(): Promise<void> {
    loopCategoria: for (const categoria of this.NAVEGACION) {
      for (const pagina of categoria.paginas) {
        const autorizado = await this.autorizacionService.tieneAutorizacion$(pagina.autorizacion);
        if (autorizado) {
          this.mostrarCategoria.update((mostrar) => {
            mostrar.set(categoria.nombre, true);
            return mostrar;
          });
          continue loopCategoria;
        }
      }
      this.mostrarCategoria.update((mostrar) => {
        mostrar.set(categoria.nombre, false);
        return mostrar;
      });
    }
    this._cdr.markForCheck();
  }
}
